import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Dialog, DialogTitle, Typography, Button, DialogContent } from "@mui/material";

import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"


import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { FullscreenExit, SettingsPowerRounded } from "@mui/icons-material";
import { selectReportCriteriaEntities } from "../../../reducers/admincenter_reportcriteria";
import { selectReportsForGuid } from "../../../reducers/reference_reportproduct";
import ResponsiveRectangle from "../skeletons/ResponsiveRectangle";
import DataReportTable from "./ReportDataReportTable";
import { selectUIReportEntities } from "../../../reducers/admincenter_uireport";
import DynamicComponent from "../DynamicComponent";





const ReportUIReport = () => {


    const DataReportStatus = useSelector(state => state.datareports.status)
    const ReportProductsStatus = useSelector(state => state.reportproducts.status)
    const UIReportStatus = useSelector(state => state.uireports.status)
    const ReportCriteria = useSelector(state => selectReportCriteriaEntities(state))
    const ReportArray = useSelector(state => selectReportsForGuid(state, ReportCriteria.ReportGuid))
    const ReportObject = ReportArray && ReportArray[0] ? ReportArray[0] : []
    const ReportJSON = useSelector(state => selectUIReportEntities(state))

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
console.log(ReportJSON)
    const cannotReadOnlyNonSense = [...ReportJSON]
    const FilteredSections = cannotReadOnlyNonSense.filter(x => { return x.Visible === '1' })
    const OrderedSections = FilteredSections.sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })



    /*if (!currentUser) {
      return <Navigate to="/login" />;
    }*/

    useEffect(() => { }, [dispatch, UIReportStatus, ReportObject])


    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }


    return (

        <>
            {UIReportStatus === 'success' ? (
                <Grid container direction="row" spacing={2} alignItems="top" justifyContent="center">

                    {/** The idea is simple, we will send each array to a single component that will dictate its format */}
                    {/** Each array will have a ComponentType attribute. [{ComponentType},{ComponentType},{ComponentType}] */}
                    {/** This component type will load a specific component*/}

                    {
                        OrderedSections.map((reportComponent, index) => {
                            return (

                                <DynamicComponent component={reportComponent} delay={index} key={index} elevationdisabled={true}/>

                            )
                        })
                    }


                </Grid>
            ) : UIReportStatus === 'loading' ? (
                <ResponsiveRectangle height="40" />
            ) : (
                <></>
            )
            }
        </>


    )

};

export default ReportUIReport;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */